import listTemplate from './views/pages/list.tpl.html';
import detailsTemplate from './views/pages/details.tpl.html';
import WalletTemplatesListController from './controllers/pages/list';
import WalletTemplatesDetailsController from './controllers/pages/details';

angular
    .module('festzelt-os.modules.wallets.templates')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.wallets.templates', {
            abstract: true,
            url: 'templates',
            template: '<ui-view/>',
        })
        .state('app.wallets.templates.index', {
            url: '',
            sticky: true,
            templateUrl: listTemplate,
            controller: WalletTemplatesListController,
            controllerAs: 'vm',
            data: {
                right: 'passbooks::list'
            }
        })
        .state('app.wallets.templates.details', {
            url: '/{id}',
            sticky: true,
            templateUrl: detailsTemplate,
            controller: WalletTemplatesDetailsController,
            controllerAs: 'vm',
            params: {
                id: {
                    type: 'int'
                }
            },
            data: {
                right: 'passbooks::create'
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/routes.js